export const InternalOrderColumn = [
  // {
  //   accessor: "driverId",
  //   Header: "",
  //   key: "id",
  //   header: "",

  // },
  {
    accessor: 'senderHub',
    Header: 'هاب مقصد',
    key: 'senderHub',
    header: 'هاب مقصد',
  },

  {
    accessor: 'trackingNumber',
    Header: "شماره سفارش",
    key: 'trackingNumber',
    header: "شماره سفارش",
  },
  {
    accessor: 'creationDate',
    Header: 'تاریخ ',
    key: 'creationDate',
    header: 'تاریخ',
  },
  {
    accessor: 'numberOfConsignments',
    Header: 'تعداد مرسوله ',
    key: 'numberOfConsignments',
    header: 'تعداد مرسوله',
  },
  {
    accessor: 'status',
    Header: 'وضعیت ',
    key: 'status',
    header: 'وضعیت',
  },
 

  {
    Header: 'عملیات',
    accessor: 'operation',
    key: '',
    header: '',
  },
]
